import React, { Component } from 'react';
import styles from './user-members-list-heading.scss';

export class UserMembersListHeading extends Component<{ translation }> {

  public render() {
    const { translation } = this.props;

    return <div className={styles.headingContainer}>
      <div className={styles.defaultColumn}>{translation.filter_name}</div>
      <div className={styles.defaultColumn}>{translation.filter_email}</div>
      <div className={styles.fixedColumn} />
    </div>;
  }
}
